export default __webpack_public_path__ + "static/media/basic-english.5b9ccfc6.png";